<template>
  <app-main>
    <template v-if="$route.query.inApp != 3 || $route.query.isShowTitle">
      <app-header slot="header" color="is-default" :is_display_down="false"></app-header>
    </template>
    <img class="p-img" src="https://app.jaadee.com/static/page/promise/top.jpg" />
    <div class="content">
      <div class="title">保真承诺细则</div>
      <div class="pa">“让所有珠宝玉石消费者不买假、不买错，构建一个客观公正的信赖体系”，是我们翡翠王朝的矢志追求。翡翠王朝作为中国珠宝玉石首饰行业协会核心成员，云南省珠宝玉石文化促进会常务副会长单位，瑞丽市宝玉石协会副会长单位，自成立以来始终坚持立足源头，为广大翠友提供一手精品货源和源头精品宝玉石，已为超过百万的顾客提供过优质服务，累计售100多万件翡翠，未发现一件假货。</div>
      <div class="pa">为确保货品质量，我们聘请以“东方珠宝教父”肖永福为代表的专家团队为我们的产品把关，并与国家珠宝玉石质量监督检验中心（NGTC）、广东GTC珠宝检测中心、云南质量技术监督局质检院、四川省珠宝检测院等权威检测机构长期合作。翡翠王朝每一件宝贝寄出前，均送国家认证资质的权威检测机构进行检测，并出具正规鉴定证书。鉴定结果（检验结论）符合您所购买宝贝的材质，方可发货。</div>
      <div class="pa">为更进一步完善交易保障，真正做到让所有人放心购买，我们正式推出以下承诺：</div>
      <div class="title">保真承诺</div>
      <div class="des1">适用对象</div>
      <div class="pa">所有在翡翠王朝购买的翡翠、和田玉、南红、琥珀蜜蜡、彩色宝石等在售珠宝玉石类成品（不包括翡翠原石和其他未经加工的珠宝原材料及一切由商户自行直接发货的产品，也不包括搭配的配饰、活动赠品等附带品）。</div>
      <div class="des1">承诺内容</div>
      <div class="pa">翡翠王朝所售产品均经下列经国家认定资质的权威检测机构之一进行检测，并出具随货的检测证书。所有随货证书均可在出具报告的检验机构进行核实验证，确保您购买的是真品。</div>
      <div class="title2">翡翠王朝合作权威检测机构名单：</div>
      <div class="cor mar">国家珠宝玉石质量监督检验中心</div>
      <div class="cor">证书查询地址：http://www.ngtc.com.cn/</div>
      <div class="cor mar">中国地质大学珠宝检测中心</div>
      <div class="cor">证书查询网址：www.gic.cug.edu.cn</div>
      <div class="cor mar">云南省珠宝玉石质量监督检验研究院</div>
      <div class="cor">证书查询网址：www.giyn.net</div>
      <div class="cor mar">四川省珠宝玉石首饰产品质量监督检验中心</div>
      <div class="cor">证书查询网址：www.cqi.org</div>
      <div class="cor mar">广东省技术监督珠宝贵金属质量检验站</div>
      <div class="cor">证书查询网址：www.gtc-china.cn</div>
      <div class="cor mar">广东省质量监督金银珠宝检验站</div>
      <div class="cor">证书查询网址：www.gdtc.cc</div>
      <div class="cor mar">国土资源部广州矿产资源监督检测中心</div>
      <div class="cor">证书查询网址：www.gtzy123.com</div>
      <div class="des1">承诺责任</div>
      <div class="pa">买家收到货品后，可选择上述任意一家检验机构进行复检（南红、和田玉、彩色宝石、琥珀蜜蜡等部分材质因为各地行业标准不一，需到原出具证书机构复检）。如复检鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致（不包括物理化学性状的优化处理，如烤色、加热、注胶等），翡翠王朝将针对该笔订单进行处理及赔偿，假一赔十。如客户复检结果（检验结论）存在物理化学性状的优化处理，翡翠王朝将针对该笔订单进行退款退货处理，退货过程产生的运费均由翡翠王朝承担。</div>
      <div class="des1">关于毛料售后</div>
      <div class="pa">针对毛料（原石）售后服务及财物保管，除正常售后流程范畴外，商户代买家保管财物期限为自订单生成起30天内，如买家超过30天无任何后续处理，商户将默认自动发货以终结订单。</div>
      <div class="des1">关于假货</div>
      <div class="pa">复检证书鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致，凡是材质本身复检结果不是该类货品的都可称之为假货，如随货鉴定证书显示为翡翠的货品，复检结果明确排除翡翠的，则可视为假货处理；但对于行业标准不一致引起的歧义性结论，如将“南红”鉴定为“南红玛瑙”或“玛瑙”，则复检鉴定不构成假货的依据。构成假货的，翡翠王朝将按照约定针对该笔订单进行赔偿，按订单价赔偿十倍金额并收回货品。</div>
      <div class="des1">关于优化处理</div>
      <div class="pa">复检证书鉴定材质本身结果相同，但存在物理化学性状上的差异，如烤色、加热、注胶等优化处理情况，则不视为假货范畴，翡翠王朝将针对该笔订单进行退货退款处理，退货过程产生的费用均由翡翠王朝承担。</div>
      <div class="des1">什么是优化处理</div>
      <div class="pa">珠宝玉石从开采加工到销售的多个环节中，因为美化的需要，会经过一系列的优化处理，如加热、填充、烤色等优化处理的情形，常见的南红注胶、琥珀蜜蜡的烤色、宝石热处理和注油等处理。保真仅限于对物品材质类别的真假做鉴定，各类优化和问题均不在保真范围，不视为假货。</div>
      <div class="pa">关于和田玉的皮色的补充说明：目前大多鉴定机构都不对和田玉皮色成因进行鉴定，所以和田玉皮色真假鉴定暂不在保真范围内！</div>
      <div class="pa">若因国家、行业市场标准、检测机构鉴定标准发生变化，导致在以上鉴定机构无法出具复检证书或者证书鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致的，可联系平台客服进行申请处理。</div>
      <div class="pa">注：以上属特殊情形，均不能发起赔偿申请。</div>
      <div class="des1">赔偿流程</div>
      <div class="pa no-index">1、对于存疑的货品，买家须送至以上鉴定机构之一进行复检并出具检测报告。</div>
      <div class="pa no-index">2、持复检证书鉴定结果（检验结论）向翡翠王朝专属客服进行理赔。</div>
      <div class="pa no-index">3、在责任明确、材料齐全的情况下，翡翠王朝将确认赔偿。</div>
      <div class="pa no-index">4、买家将货品寄回翡翠王朝。</div>
      <div class="des1">免责情形</div>
      <div class="pa no-index">当发生下列情形之一，翡翠王朝不负责赔偿任何损失、费用：</div>
      <div class="pa no-index">1、买家故意欺诈，或知假买假，或不按正常流程交易;</div>
      <div class="pa no-index">2、买家对货品进行二次处理，使货品外观和性状发生改变;</div>
      <div class="pa no-index">3、货品在签收后受到人为损坏或遗失;</div>
      <div class="pa no-index">4、国家认可的、带有CMA/CAL/CNAL等标识的鉴定机构无法对货品性质做出明确鉴定结果;</div>
      <div class="pa no-index">5、因国家、行业市场标准、检测机构鉴定标准发生变化，导致在以上鉴定机构无法出具复检证书或者证书鉴定结果（检验结论）与随货鉴定证书的鉴定结果（检验结论）不一致的；</div>
      <div class="pa no-index">6、就同一订单发起两次及以上理赔申请，第二次及第二次以上索赔部分不具有效力;</div>
      <div class="pa no-index">7、战争、敌对行动、军事行为、武装冲突、罢工、骚乱、暴动及恐怖袭击；</div>
      <div class="pa no-index">8、核辐射、核爆炸、核污染及其他放射性与非放射性污染；</div>
      <div class="pa no-index">9、政府部门征用、扣押、罚没及其他行政行为与司法行为；</div>
      <div class="pa no-index">10、其他依法不应当进行赔偿规定的情况。</div>
      <div class="des1">特别说明</div>
      <div class="pa">翡翠王朝保留不时对本承诺细则进行修改的权利，修改后的细则将以同样方式予以公示，并自公示之日起生效。</div>
    </div>
    <div v-show="course" class="course">
      <div class="name">公司历程</div>
      <p>翡翠王朝2008年创立于中缅边境的云南瑞丽，历经十余年发展，已成为中国最大的珠宝玉石互联网品牌，是中国珠宝玉石首饰协会成员，被品牌行业促进会、民营企业家协会等多家单位联合评为良心企业、匠心品牌，获得云南省委书记点赞和百万顾客信赖。目前，翡翠王朝在产业资源开发、互联网信息技术、珠宝电子商务以及珠宝玉石文化传播等方面在国内处于领先水平。</p>
      <history :kaiguan=fo></history>
    </div>
  </app-main>
</template>

<script>
import AppMain from '../layouts/Main';
import AppHeader from '../layouts/Header';
import history from './components/us/History'
import { setStatusTextColor } from '../../RNApp'
export default {
  name: "Promise",
  components: {
    AppMain, AppHeader, history
  },
  data() {
    return {
      course: true,
      fo:true
    }
  },
  mounted() {
    window.scrollTo(0, 0)
  },
  created() {
    if (this.$route.query.courseShow == 0) {
      this.course = false
    }
    setStatusTextColor("black");
  },

destroyed(){
   setStatusTextColor("white");
  }
}
</script>

<style scoped>
body {
  background-color: #ffffff;
}
body div {
  text-align: left;
  line-height: 0.34rem;
}
.bor-box {
  background-color: #ffffff;
  min-height: 100vh;
}
.mheight {
  height: 1.4rem;
}
.p-img {
  width: 100%;
  display: block;
}
.content {
  padding: 0 0.4rem 0.4rem;
}
.title {
  color: #c5913f;
  font-size: 0.3rem;
  text-align: center;
  font-weight: bold;
  margin: 0.3rem 0;
}
.pa {
  color: #414141;
  text-indent: 0.4rem;
  font-size: 0.2rem;
  text-align: justify;
}
.des1 {
  color: #c5913f;
  font-size: 0.21rem;
  display: table;
  border: 0.01rem solid #c5913f;
  padding: 0 0.1rem;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
}
.title2 {
  font-size: 0.2rem;
  color: #414141;
  margin-top: 0.4rem;
  font-weight: bold;
}
.mar {
  margin-top: 0.4rem;
}
.cor {
  color: #c5913f;
  font-size: 0.2rem;
}
.no-index {
  text-indent: 0;
}
.course {
  margin-top: 0.2rem;
}
.course .name {
  width: 100%;
  font-size: 0.24rem;
  color: #358539;
  text-align: center;
  font-weight: bold;
}
.course p {
  padding: 0 0.4rem;
  margin-top: 0.2rem;
  box-sizing: border-box;
  font-size: 0.16rem;
  text-indent: 2em;
}
</style>
